import { render, staticRenderFns } from "./AccessBlocked.vue?vue&type=template&id=343b3807"
import script from "./AccessBlocked.vue?vue&type=script&lang=js"
export * from "./AccessBlocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports